//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PublicPageLayout from './PublicPageLayout';
import { formatNumber } from 'src/util/filter';
import validation, {
	required,
	email,
	phone,
} from 'src/util/validation';

const ENERGY_EFFICIENCY_CLASSES = [{
	tag: 'A+++',
	color: '#009640',
}, {
	tag: 'A++',
	color: '#009640',
}, {
	tag: 'A+',
	color: '#52ae32',
}, {
	tag: 'A',
	color: '#c8d400',
}, {
	tag: 'B',
	color: '#c8d400',
}, {
	tag: 'C',
	color: '#ffed00',
}, {
	tag: 'D',
	color: '#ec6608',
}, {
	tag: 'E',
	color: '#e30613',
}, {
	tag: 'F',
	color: '#e30613',
}, {
	tag: 'G',
	color: '#e30613',
}];

export default {
	name: 'VehicleDetail',
	components: {
		PublicPageLayout,
	},
	mixins: [validation],
	ENERGY_EFFICIENCY_CLASSES,
	data: () => ({
		loadingData: true,
		vehicle: {},
		dealer: {},
		dealerLogo: null,
		slide: 0,
		imageSliderFullscreen: false,
		sendingForm: false,
		form: {
			name: '',
			email: '',
			phoneNumber: '',
			freeFormText: '',
			agbChecked: false,
		},
	}),
	validation: {
		name: [
			required('Bitte füllen Sie dieses Feld aus!'),
		],
		email: [
			required('Bitte füllen Sie dieses Feld aus!'),
			email('Dies ist keine valide E-Mail'),
		],
		phoneNumber: [
			required('Bitte füllen Sie dieses Feld aus!'),
			phone('Dies ist keine valide Telefonnummer'),
		],
		freeFormText: [
			required('Bitte füllen Sie dieses Feld aus!'),
		],
	},
	async mounted() {
		const { dealerId, vehicleId } = this.$route.params;
		try {
			const { data } = await this.$axios.get(`/dealer/${dealerId}/vehicle/${vehicleId}`);
			this.vehicle = data.vehicle || {};
			this.dealer = data.dealer || {};
		} catch (error) {
			console.error(error);
		}
		this.loadingData = false;
		this.dealerLogo = await this.$axios.get(`/dealer/${dealerId}/logo`)
			.then(({ data }) => data.url)
			.catch(console.error);
	},
	computed: {
		phoneNumber() {
			if (!this.dealer.phoneNumber) return null;
			return this.dealer.phoneNumber
				.replace(/\(0\)|[ /D-]/g, '')
				.replace(/^0049/, '+49')
				.replace(/^0/, '+49');
		},
		bodyStyle() {
			switch (this.vehicle.bodyStyle) {
				case 'convertible': return 'Cabrio';
				case 'wagon': return 'Kombi';
				case 'sedan': return 'Limousine';
				case 'suv': return 'SUV';
				case 'small_car':
				case 'hatchback': return 'Kleinwagen';
				case 'coupe': return 'Coupé';
				case 'van': return 'Van / Minibus';
				case 'truck': return 'LKW';
				default: return null;
			}
		},
		transmission() {
			switch (this.vehicle.transmission) {
				case 'MANUAL': return 'Schalter';
				case 'AUTOMATIC': return 'Automatik';
				default: return 'n/a';
			}
		},
		power() {
			if (!this.vehicle.powerKw) return 'n/a';

			const powerKw = parseInt(this.vehicle.powerKw);
			const powerPs = Math.round(powerKw * 1.3596);

			return `${powerKw} kW / ${powerPs} PS`;
		},
		fuelType() {
			switch (this.vehicle.fuelType) {
				case 'GASOLINE': return 'Benzin';
				case 'HYBRID': return 'Hybrid';
				case 'DIESEL': return 'Diesel';
				case 'ELECTRIC': return 'Strom';
				case 'OTHER': return 'andere';
				default: return 'n/a';
			}
		},
		cubicCapacity() {
			if (!this.vehicle.cubicCapacity) return 'n/a';
			return `${formatNumber(this.vehicle.cubicCapacity)} ccm`;
		},
		vehicleState() {
			switch (this.vehicle.vehicleState) {
				case 'used': return 'Gebrauchtwagen';
				case 'new': return 'Neuwagen';
				default: return 'n/a';
			}
		},
		mileage() {
			if (!this.vehicle.mileage) return 'n/a';
			return `${formatNumber(this.vehicle.mileage)} km`;
		},
		gasMileageCombined() {
			if (!this.vehicle.gasMileageCombined) return 'n/a';
			return `${formatNumber(this.vehicle.gasMileageCombined, { fractionDigits: 1 })} l/100 km`;
		},
		gasMileageCity() {
			if (!this.vehicle.gasMileageCity) return 'n/a';
			return `${formatNumber(this.vehicle.gasMileageCity, { fractionDigits: 1 })} l/100 km`;
		},
		gasMileageHighway() {
			if (!this.vehicle.gasMileageHighway) return 'n/a';
			return `${formatNumber(this.vehicle.gasMileageHighway, { fractionDigits: 1 })} l/100 km`;
		},
		co2() {
			if (!this.vehicle.co2) return 'n/a';
			return `${formatNumber(this.vehicle.co2)} g/km (komb.)`;
		},
		consumptionFuelCombined() {
			if (!this.vehicle.consumptionFuelCombined) return 'n/a';
			return `${formatNumber(this.vehicle.consumptionFuelCombined, { fractionDigits: 1 })} l/100 km`;
		},
		consumptionPowerCombined() {
			if (!this.vehicle.consumptionPowerCombined) return 'n/a';
			return `${formatNumber(this.vehicle.consumptionPowerCombined, { fractionDigits: 1 })} kWh/100 km`;
		},
		co2EmissionCombined() {
			if (!this.vehicle.co2EmissionCombined) return 'n/a';
			return `${formatNumber(this.vehicle.co2EmissionCombined, { fractionDigits: 1 })} g/km`;
		},
		electricRange() {
			if (!this.vehicle.electricRange) return 'n/a';
			return `${formatNumber(this.vehicle.electricRange)} km`;
		},
		consumptionFuelCombinedWeighted() {
			if (!this.vehicle.consumptionFuelCombinedWeighted) return 'n/a';
			return `${formatNumber(this.vehicle.consumptionFuelCombinedWeighted, { fractionDigits: 1 })} l/100 km`;
		},
		consumptionPowerCombinedWeighted() {
			if (!this.vehicle.consumptionPowerCombinedWeighted) return 'n/a';
			return `${formatNumber(this.vehicle.consumptionPowerCombinedWeighted, { fractionDigits: 1 })} kWh/100 km`;
		},
		co2EmissionCombinedWeighted() {
			if (!this.vehicle.co2EmissionCombinedWeighted) return 'n/a';
			return `${formatNumber(this.vehicle.co2EmissionCombinedWeighted, { fractionDigits: 1 })} g/km`;
		},
		description() {
			if (!this.vehicle.description) return 'n/a';
			return this.vehicle.description.replace(/\n/g, '<br />');
		},
	},
	methods: {
		efficiencyClassWidth(index) {
			const min = 20;
			const max = 67;
			const steps = ENERGY_EFFICIENCY_CLASSES.length - 1;
			return min + (max - min) / steps * index;
		},
		resetForm() {
			this.form.name = '';
			this.form.email = '';
			this.form.phoneNumber = '';
			this.form.freeFormText = '';
		},
		async sendForm() {
			const validated = await this.validate();
			if (!validated) return;

			if (this.$options.dismissError) this.$options.dismissError();
			this.sendingForm = true;

			const formData = {
				name: this.form.name,
				email: this.form.email,
				phoneNumber: this.form.phoneNumber,
				freeFormText: this.form.freeFormText,
			};

			try {
				await this.$axios.post(`/dealer/${this.dealer.ID}/vehicle/${this.vehicle.ID}`, formData);
				this.resetForm();
				this.$q.notify.info(
					'Vielen Dank für Ihre Anfrage!'
				);
			} catch (error) {
				if (!error.handled) {
					console.error(error);
					this.$options.dismissError = this.$q.notify.error(
						'Es ist ein Fehler beim Senden des Formulares aufgetreten!'
					);
				}
			}

			this.sendingForm = false;
		},
	},
};
